import { Components, Theme } from '@mui/material';

export function getMuiLink(theme: Theme): Components['MuiLink'] {
  return {
    styleOverrides: {
      root: {
        textDecoration: 'none',

        '&, &:visited': {
          color: theme.palette.grey[600],
        },

        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
    },
  };
}
